export const noDataLabel = '[Data is niet beschikbaar]';

export const maximumOrderTotal = 10 ** 6;
export const productIsNewThresholdInDays = 30;
